export enum TelaFinancasEnum {
    ContasPagar = 1,
    ContasReceber = 2
}
